/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { trackEvent } from 'src/utils/segmentService';
import {
  SearchInputStyles,
  SearchTailingStyles,
  SearchWrapperStyles,
  TextFieldWrapper,
} from './SearchSongArtist.styles';

interface SearchSongArtistProps {
  handleSearch: (searchParam: string) => void;
}

const SearchSongArtist: React.FC<SearchSongArtistProps> = ({
  handleSearch,
}) => {
  const { t } = useTranslation();

  // Handling search by song-artist
  const search = (event: any) => {
    const target = event.target as HTMLInputElement;
    handleSearch(target?.value as unknown as string);
  };

  // Tracking search event on blur
  const handleSearchBlur = (event: any) => {
    const { value } = event.target as HTMLInputElement;
    if (value) {
      trackEvent('Library Search', {
        type: 'library_search',
        source: 'dashboard_library_page',
        search_term: value,
      });
    }
  };

  return (
    <>
      {/*  Search song-artist */}
      <TextFieldWrapper
        id="search"
        name="search"
        setting="mtr"
        labelText=""
        placeholder={t('LIBRARY_SEARCH_PLACEHOLDER')}
        width="336"
        tailingIcon="Search"
        onChange={search as () => void}
        onBlur={handleSearchBlur}
        wrapperStyles={{ ...SearchWrapperStyles }}
        inputStyle={{ ...SearchInputStyles }}
        tailingStyle={{ ...SearchTailingStyles }}
      />
    </>
  );
};

export default SearchSongArtist;
